<template>
  <div class="comment__audit__deleted-file">
    <FilePic :isRemoved="true" />
    <BaseSubHeading
      size="small"
      weight="500"
    >
      {{ deletedFileMetadata?.name }}
    </BaseSubHeading>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import FilePic from "@/components/File/FilePic.vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const deletedFileMetadata = computed(
  () => props.comment.itemAuditRecord?.before?.deletedFileMetadata
)
</script>
